export default "__VITE_ASSET__WXmwICxQ__"